// extracted by mini-css-extract-plugin
export default {"rateButton":"mBI1X","selected":"k8SFO","modal":"np9wn"};